import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {UserService} from "../services/user.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(protected router: Router, protected userService: UserService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.userService.isLogged().then(value => {
      if (value) {
        let rol = this.userService.getUser().idPermiso;
        if ((route.data)['role'].includes(rol)) {
          return true;
        } else {
          this.router.navigate(["/home"]);
          return false;
        }
      } else {
        this.userService.logOut();
      }
    });
  }

}
